const normalize = (value = "") => value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
const numberFrom = (value) => Number(String(value).replace(/\s/g, "").replace(",", "."));

export function parseQuickListing(rawText) {
  const raw = String(rawText || "").trim();
  const text = normalize(raw);
  const detected = [];
  const inferred = [];
  const specs = {};
  const add = (key, label, value, source, kind = "detected") => {
    if (value === undefined || value === null || value === "") return;
    (kind === "inferred" ? inferred : detected).push({ key, label, value, source, kind });
  };

  const categories = [["immeuble de rapport","immeuble"],["appartement","appartement"],["studio","studio"],["duplex","duplex"],["parcelle","terrain"],["terrain","terrain"],["maison","maison"],["villa","villa"],["bureau","bureau"],["entrepot","entrepot"]];
  const category = (categories.find(([needle]) => text.includes(needle)) || ["","villa"])[1];
  const purpose = /\b(a louer|location|loue)\b/.test(text) ? "rent" : /\b(a vendre|vente|vend)\b/.test(text) ? "sale" : "rent";
  add("sector","Univers","Immobilier",raw.split(/\r?\n/)[0] || raw);
  add("purpose","Transaction",purpose === "rent" ? "Location" : "Vente",raw.split(/\r?\n/)[0] || raw);
  add("category","Type",category,raw.split(/\r?\n/)[0] || raw);

  const places = ["Gombe","Ngaliema","Limete","Kintambo","Lingwala","Barumbu","Kinshasa","Lemba","Matete","Masina","Nsele","Mont-Ngafula"];
  const place = places.find((name) => text.includes(normalize(name)));
  if (place) {
    add("zone","Commune / zone",place,place);
    if (normalize(place) !== "kinshasa") add("city","Ville","Kinshasa",place,"inferred");
  }
  const bedrooms = text.match(/(\d+)\s*chambres?\b/);
  if (bedrooms) { specs.chambres = numberFrom(bedrooms[1]); add("chambres","Chambres",specs.chambres,bedrooms[0]); }
  const salons = text.match(/(\d+)\s*salons?\b/);
  if (salons) specs.salons = numberFrom(salons[1]); else if (/\bdouble salon\b/.test(text)) specs.salons = 2;
  if (specs.salons) add("salons","Salons",specs.salons,salons?.[0] || "double salon");
  if (/\bparking\b/.test(text)) { specs.parking_places = 1; add("parking_places","Parking","Oui","parking"); }

  const priceMatch = raw.match(/(?:(?:USD|US\$|\$)\s*(\d[\d\s.,]*)|(\d[\d\s.,]*)\s*(?:USD|US\$|\$))(?=\s*(?:[x×]\s*\d+\s*\+\s*\d+|$|\n))/i);
  let price = "";
  if (priceMatch) {
    price = numberFrom((priceMatch[1] || priceMatch[2]).replace(/\.(?=\d{3}\b)/g, ""));
    if (price > 0) add("price",purpose === "rent" ? "Loyer mensuel" : "Prix",price.toLocaleString("fr-FR") + " USD",priceMatch[0].trim());
  }
  const terms = text.match(/(?:x|×)\s*(\d+)\s*\+\s*(\d+)/);
  if (terms && purpose === "rent") {
    specs.avance_mois = numberFrom(terms[1]);
    specs.commission_mois = numberFrom(terms[2]);
    add("avance_mois","Avance",specs.avance_mois + " mois",terms[0]);
    add("commission_mois","Commission Team Work",specs.commission_mois + " mois",terms[0]);
  }
  const negotiable = /\bnegociable\b/.test(text);
  if (negotiable) add("negotiable","Prix négociable","Oui","négociable");
  const title = (raw.split(/\r?\n/).find(Boolean) || "Nouvelle annonce immobilière").trim();
  return { form:{sector:"real_estate",purpose,category,title,price,currency:"USD",price_period:purpose==="rent"?"month":"",negotiable,city:place?"Kinshasa":"",zone:place||"",specs}, detected, inferred };
}